import { defineStore } from 'pinia'
import type { VirementDTO } from '@/features/api/extranet/dto/Virement'
import { shallowRef } from 'vue'
import * as services from '@/features/services/detail/virement/VirementService'

export const useVirementStore = defineStore('virement', () => {
  const model = shallowRef<VirementDTO>()

  async function loadData(code: string) {
    model.value = await services.loadVirement(code)
  }
  return {
    model,
    loadData
  }
})
